var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8432_94185)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "#304766"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8432_94185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.664593 6.91056C0.272817 6.11255 0.604313 5.14868 1.40559 4.75851C2.20657 4.36804 3.17403 4.69874 3.5658 5.49675C3.97646 6.33022 4.61344 7.01534 5.38319 7.49279C6.14757 7.9672 7.04574 8.23233 7.98734 8.23233C8.93939 8.23233 9.84453 7.96358 10.6096 7.48396C11.3824 6.99986 12.0199 6.30445 12.4276 5.45825C12.8123 4.65662 13.7768 4.31753 14.5813 4.70062C15.3861 5.08385 15.7264 6.04482 15.3416 6.84645C14.661 8.25867 13.6061 9.41242 12.3325 10.2104C11.0507 11.0138 9.55081 11.4637 7.98734 11.4637C6.43505 11.4637 4.94638 11.022 3.67315 10.2318C2.4063 9.44628 1.35314 8.3073 0.664593 6.91056Z",
    fill: "#08D17A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8432_94185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8432_94185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.bf09a26d775bcc2084359e63e2483f84.svg";
export { ForwardRef as ReactComponent };